import styled from "styled-components";

export const AboutListContainer = styled.div`
  display: flex;
  flex: 1;
`;
